import {Component } from '@angular/core';
import { SalesFinalInstructionsClientComponent } from "../sales-final-instructions-client.component";

@Component({
  selector: 'app-sales-final-instructions-client-v2',
  templateUrl: './sales-final-instructions-client-v2.component.html'
})
export class SalesFinalInstructionsClientV2Component extends SalesFinalInstructionsClientComponent { }

@Component({
  selector: 'app-sales-final-instructions-client-v3',
  templateUrl: './sales-final-instructions-client-v3.component.html',
})
export class SalesFinalInstructionsClientV3Component extends SalesFinalInstructionsClientComponent { }

